import './change-password/change-password.component';
import './reset-password/reset-password.component';
import './user-details/user-details.component';
import './user-status/user-status.component';
import './user-status/notification-details/notification-details.component';
import './user-status/send-notification/send-custom-notification.component';
import './change-company/change-company.component';